module.exports = __webpack_public_path__ + "img/icon-new.7d2021d.png";